import { render } from "./DocumentsUpload.vue?vue&type=template&id=5f863a62&scoped=true"
import script from "./DocumentsUpload.vue?vue&type=script&lang=js"
export * from "./DocumentsUpload.vue?vue&type=script&lang=js"

import "./DocumentsUpload.vue?vue&type=style&index=0&id=5f863a62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f863a62"]])

export default __exports__